
/**
 * 상세 에러 정보
 * @nullable
 */
export type GetApiV1RefundsMyRequests500ErrorDetails = { [key: string]: unknown } | null;
